import React from 'react';
import SmartDialog from "../../../../components/SmartDialog";
import {Form, Formik} from "formik";
import TTLProxy from "../../../../common/TTLAsyncProxy";
import * as Yup from 'yup';
import {Button} from "reactstrap";
import FormInput from "../../../../components/FormInput";
import MDProgress from 'react-md-progress-bar';
import {MiscEndpoints} from "../../../../common/ProxyEndpoints";
import HTML from '../../../../common/HtmlHelpers';
import Utils from "../../../../common/Utils";
import PropTypes from 'prop-types';

const PricingGroupSchema = Yup.object().shape({
    name: Yup.string().required("Enter a valid region name").label("Name"),
    description: Yup.string().label("Description").notRequired()
});

class RegisterRegionDialog extends React.Component {

    static propTypes = {
        onRegistered: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = RegisterRegionDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(){

        return {

        };

    }

    show(){

        this.setState(RegisterRegionDialog.getInitialState(),() => {
            this._dlg.show();
        });

    }

    async onSubmit(values){

        try {

            const response = await this.proxy.processRequest(MiscEndpoints.createPricingGroup({
                ...values,
                active: true // initially active
            }));

            if(response.ok){

                //  toast
                HTML.toastSuccess('Segment created successfully');

                if(this.props.onRegistered)
                    this.props.onRegistered(response.getPayload());

                //  hide dialog
                this._dlg.hide();
            }

        }
        catch (e) {
            HTML.toastWarning(Utils.getResponseError(e));
        }

    }

    render(){

        return <SmartDialog title="Register Price Segment" ref={r => this._dlg = r}>

            <Formik  initialValues={{
                        name: '',
                        description: ''
                     }}
                     validationSchema={PricingGroupSchema}
                     onSubmit={async (values,{ setSubmitting }) => {

                        try{
                            await this.onSubmit(values);
                        }
                        catch (e) {

                            //  failed

                        }
                        finally {
                            setSubmitting(false);
                        }

                    }}>

                {({ isValid , isSubmitting }) => {

                    return <Form>

                        <FormInput name="name"
                                   type="text"
                                   title="Segment Name"
                                   icon="fa fa-globe"
                                   placeholder="Enter segment name"/>

                        <FormInput name="description"
                                   type="text"
                                   rows={2}
                                   title="Description"
                                   icon="fa fa-comment"
                                   placeholder="Enter brief description here"/>

                        <hr/>

                        {isSubmitting && <MDProgress show/>}

                        <div className="clearfix">
                            <div className="pull-right">
                                <Button color="green" disabled={!isValid}><i className="fa fa-plus"/> Register Segment</Button>
                            </div>
                        </div>
                    </Form>

                }}
            </Formik>

        </SmartDialog>

    }

}

export default RegisterRegionDialog;


// WEBPACK FOOTER //
// ./src/views/Extras/Services/USSDServices/RegisterRegionDialog.js